import React from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = ({ isMenuOpen, setIsMenuOpen, scrollY, scrollToSection }) => {
  const navItems = [
    { name: 'Home', id: 'home' },
    { name: 'About', id: 'about' },
    { name: 'Products', id: 'products' },
    { name: 'Sample Room', id: 'sample-room' },
    { name: 'Brands', id: 'brands' },
    { name: 'Our Clients', id: 'clients' },
    { name: 'Contact', id: 'contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrollY > 50 ? 'bg-white shadow-md py-2' : 'bg-white/95 py-4'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center">
        {/* Logo -> always go to homepage top via scrollToSection('home') */}
        <button
          type="button"
          onClick={() => scrollToSection('home')}
          className="text-2xl font-playfair font-bold text-gray-900 focus:outline-none"
        >
          Sudharma<span className="text-amber-700"> Clothing</span>
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="font-semibold text-gray-800 hover:text-amber-700 transition-all duration-300 relative group"
            >
              {item.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-amber-700 transition-all duration-300 group-hover:w-full"></span>
            </button>
          ))}

          {/* Policies link (goes to /privacy-policy) */}
          <Link
            to="/privacy-policy"
            className="font-semibold text-gray-800 hover:text-amber-700 transition-all duration-300 relative group"
          >
            Policy
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-amber-700 transition-all duration-300 group-hover:w-full"></span>
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-800 focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="w-6 h-6" />
          ) : (
            <Menu className="w-6 h-6" />
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-left py-2 font-semibold text-gray-800 hover:text-amber-700 transition-colors"
              >
                {item.name}
              </button>
            ))}

            {/* Policies in mobile menu */}
            <Link
              to="/privacy-policy"
              onClick={() => setIsMenuOpen(false)}
              className="text-left py-2 font-semibold text-gray-800 hover:text-amber-700 transition-colors"
            >
              Policy
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
